import { useEffect, useState } from "react";

/** Current unix time in seconds, ticking once per second. */
export function useClock(): number {
	const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));
	useEffect(() => {
		const id = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
		return () => clearInterval(id);
	}, []);
	return now;
}

/** Polls the backend so the status bar can show Online/Offline. */
export function useBackendOnline(intervalMs = 60_000): boolean | null {
	const [online, setOnline] = useState<boolean | null>(null);
	useEffect(() => {
		let cancelled = false;
		const check = async () => {
			try {
				const res = await fetch("/api/intraday/session");
				if (!cancelled) setOnline(res.ok);
			} catch {
				if (!cancelled) setOnline(false);
			}
		};
		check();
		const id = setInterval(check, intervalMs);
		return () => {
			cancelled = true;
			clearInterval(id);
		};
	}, [intervalMs]);
	return online;
}
